import React from 'react'
import {Link as RouterLink} from 'react-router'
import Link from '@material-ui/core/Link'

const CollisionLink = React.forwardRef((props, ref) => (
  <RouterLink style={{textDecoration: 'none'}} {...props} />
));

export default props =>
  <Link
    component={CollisionLink}
    role="button"
    onClick={(e) => {
      e.stopPropagation()
      props.onClick && props.onClick(e)
    }}
    target={props.target}
    href={props.href}
    activeClassName={ + props.active && 'noneActiveClass' || 'page-layout__nav-item--active'} {...props}
    style={{
      ...props.style || {},
      textDecoration: 'none',
      cursor: 'pointer'
    }}>
          {props.children}
  </Link>



// WEBPACK FOOTER //
// ./app/Components/NavLink.js